import React, { useCallback, useEffect } from "react";
import { Grid, Box, Switch } from "@mui/material";
import { GridSelectionModel } from "@mui/x-data-grid";
import { GridActionsCellItem, GridRowId } from "@mui/x-data-grid-pro";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { confirm } from "react-confirm-box";
import Item from "../../Template/Item";
import { useDispatch, useSelector } from "react-redux";
import WithPermission from "../../components/WithPermission";
import TableSkeleton from "../../components/TableSkeleton";
import Dilogbox from "../../components/Dilogbox";
import { WardsForm } from "./wards-form";
import {
  loadCompanies,
  trashCompany,
  blukTrashCompany,
  getCompany,
  updateCompanyStatus,
} from "../../redux/actions/companyward.actions";
import { storeStateType } from "../../redux/store";
import { ICompanyWard } from "../../redux/reducers/companyward.reducer";
import { MultiFiltersType } from "../Worktype/Worktype";
import CustomDataGridPro from "../../components/CustomDataGridPro/CustomDataGridPro";
import CustomGridHeader from "../../components/CustomGridHeader";

// const registerSchema = object({
//   token: string(),
// });

// const invitationSchema = object({
//   facility_id: string(),
// });

// type RegisterInput = TypeOf<typeof registerSchema>;
// type InvitationInput = TypeOf<typeof invitationSchema>;
// type dataType = {
//   id: string;
//   facility_name: string;
//   facility_status: string;
//   parent_nodes: any;
//   facility_active: boolean;
// };

const customOptions = {
  render: (
    message: string,
    onConfirm: React.MouseEventHandler<HTMLButtonElement>,
    onCancel: React.MouseEventHandler<HTMLButtonElement>
  ) => {
    return (
      <Dilogbox
        isDialogOpened={true}
        handleConfirmDialog={onConfirm}
        handleCloseDialog={onCancel}
        message={message}
      />
    );
  },
};

export default function Wards() {
  const dispatch = useDispatch();

  const [page, setPage] = React.useState(0);
  const [selectionModel, setSelectionModel] =
    React.useState<GridSelectionModel>([]);
  const { companywards, total, loading, current, ward } = useSelector(
    (state: storeStateType) => state.companyward
  );

  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [editRequest, setEditRequest] = React.useState<boolean>(false);
  const [trashState, setTrashState] = React.useState<boolean>(true);
  const [handelaction, setHandelaction] = React.useState<string>("");
  const [addSubFacilty, setAddSubFacility] = React.useState<boolean>(false);
  const [pageSize, setPageSize] = React.useState<number>(10);
  const [filterData, setFilterrData] = React.useState<MultiFiltersType>({
    page: 1,
    size: 10,
  });
  const [stateFlag, setStateFlag] = React.useState<boolean>(false);
  const [paginationEvent] = React.useState<boolean>(false);
  const [csvData] = React.useState([]);
  const csvDownloadBtn = React.useRef<any>();
  const csvHeaders = [
    {
      label: `Sub Facility Name`,
      key: "facility_tree",
    },
  ];

  const handleOpen = async () => {
    setHandelaction("New Facility");
    setIsOpen(!isOpen);
    setAddSubFacility(true);
  };

  useEffect(() => {
    if (ward && editRequest) {
      setIsOpen(true);
      setEditRequest(false);
    }
  }, [ward, editRequest]);

  const deleteCompany = React.useCallback(
    (id: GridRowId, option: any) => async () => {
      const result = await confirm("Are you sure you want to delete?", option);
      if (result) {
        dispatch<any>(trashCompany(id, filterData));
        setSelectionModel([]);
        return;
      }
    },
    [dispatch, filterData]
  );
  const editFacility = React.useCallback(
    (id: GridRowId) => async () => {
      setHandelaction("Edit Facility");
      dispatch<any>(getCompany(id));
      setEditRequest(true);
      setAddSubFacility(false);
    },
    [dispatch]
  );
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    clickedRow: any
  ) => {
    const formData = new FormData();
    const data: any = event.target.checked;
    formData.append("facility_status", data);
    dispatch<any>(updateCompanyStatus(formData, clickedRow, filterData));
  };
  const label = { inputProps: { "aria-label": "Switch customfield" } };
  const columns = [
    { field: "sn", headerName: "S.N.", width: 10, filterable: false },
    {
      field: "facility_name",
      headerName: "Name",
      flex: 1,
      renderCell: (params: any) => (
        <ul className="breadcrumb">
          {[...params.row.parent_nodes].reverse().map((item: any) => (
            <li key={item.id}>{item.facility_name}</li>
          ))}
          <li key={params.row.id}>{params.row.facility_name}</li>
        </ul>
      ),
    },
    {
      field: "facility_status",
      headerName: "Active",
      width: 100,
      filterable: false,
      renderCell: (params: any) => (
        <Switch
          {...label}
          checked={params.row.facility_status}
          onChange={(e) => handleChange(e, params.row.id)}
        />
      ),
    },
    {
      field: "actions",
      type: "actions",
      minWidth: 20,
      flex: 0.1,
      getActions: (params: any) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          showInMenu
          onClick={editFacility(params.id)}
        />,
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Trash"
          showInMenu
          onClick={deleteCompany(params.id, customOptions)}
        />,
      ],
    },
  ];

  const handleTrash = async (option: any) => {
    const result = await confirm("Are you sure you want to delete?", option);
    if (result) {
      const id = {
        data: {
          id: selectionModel,
        },
      };
      dispatch<any>(blukTrashCompany(id, filterData));
      return;
    }
  };
  useEffect(() => {
    if (paginationEvent) {
      setFilterrData((prev) => ({ ...prev, page: page + 1 }));
      setStateFlag((preState) => !preState);
    }
  }, [page, paginationEvent]);

  useEffect(() => {
    dispatch<any>(loadCompanies(filterData));
  }, [stateFlag, filterData, dispatch]);

  useEffect(() => {
    if (csvData.length) {
      csvDownloadBtn.current.link.click();
    }
  }, [csvData]);
  const handleCloseWardsForm = useCallback(() => setIsOpen(false), []);

  let rows =
    Array.isArray(companywards) && companywards?.length >= 0
      ? companywards.map((companyWard: ICompanyWard, index: number) => {
          let _id = current === 1 ? 1 : 10 * (current - 1) + 1;
          return {
            id: companyWard.id,
            sn: index + _id,
            facility_name: companyWard.facility_name,
            facility_status: companyWard.facility_status,
            parent_nodes: companyWard.parent_nodes,
            facility_active: companyWard.facility_active,
          };
        })
      : [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <WithPermission
          roleReqiured={["ADMIN", "EMPLOYEE", "STAFF", "USER"]}
          message="Access Denied"
        >
          <Item>
            <CustomGridHeader
              title={`subfacility`}
              handleAddClick={handleOpen}
              handleBulkDelete={() => handleTrash(customOptions)}
              disabledTrashState={trashState}
            />
            {/* <Stack
            mb={2}
            direction="row"
            alignItems="center"
            flexWrap="wrap"
            justifyContent="space-between"
          >
            <Typography variant="h6" fontSize={"1.67rem"} gutterBottom m={1}>
              {`${menus["subfacility"] ?? ""}`}
            </Typography>
            <Box
              display="flex"
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <Button
                variant="contained"
                onClick={() => handleOpen()}
                startIcon={<AddIcon />}
                sx={{ mr: 1 }}
              >
                {`${menus["subfacility"] ?? ""}`}
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => handleTrash(customOptions)}
                disabled={trashState}
                startIcon={<DeleteIcon />}
              >
                <Hidden smDown>Trash</Hidden>
              </Button>
            </Box>
          </Stack> */}
            <Box sx={{ height: 700, width: "100%" }}>
              {rows ? (
                // <DataGridPro
                //   loading={loading}
                //   columns={columns}
                //   rows={rows}
                //   pagination
                //   checkboxSelection
                //   rowCount={total}
                //   getRowId={(rows) => rows.id}
                //   pageSizeOptions={[10, 50, 100]}
                //   paginationMode="server"
                //   rowSelectionModel={selectionModel}
                //   onRowSelectionModelChange={(newSelectionModel) => {
                //     newSelectionModel.length
                //       ? setTrashState(false)
                //       : setTrashState(true);
                //     setSelectionModel(newSelectionModel);
                //   }}
                //   initialState={{
                //     pagination: {
                //       paginationModel: {
                //         pageSize: pageSize,
                //         page: page,
                //       },
                //     },
                //   }}
                //   //keepNonExistentRowsSelected
                //   components={{
                //     Toolbar: CustomToolbar,
                //     LoadingOverlay: LinearProgress,
                //   }}
                //   componentsProps={{
                //     toolbar: {
                //       showQuickFilter: true,
                //       quickFilterProps: { debounceMs: 500 },
                //     },
                //   }}
                //   filterMode="server"
                //   onFilterModelChange={onFilterChange}
                //   onPaginationModelChange={handlePageChange}
                // />
                <CustomDataGridPro
                  rows={rows}
                  loading={loading}
                  totalRows={total}
                  columns={columns}
                  setFilterData={setFilterrData}
                  filterData={filterData}
                  csvHeaders={csvHeaders}
                  defaultCSVExport={false}
                  pageLimit={pageSize}
                  currentPage={page}
                  exportCSVUrl="/subfacility/csv"
                  setPageLimit={setPageSize}
                  setCurrentPage={setPage}
                  handleRowSelectionModelChange={(
                    newSelectionModel: React.SetStateAction<GridSelectionModel>
                  ) => {
                    newSelectionModel.length
                      ? setTrashState(false)
                      : setTrashState(true);
                    setSelectionModel(newSelectionModel);
                  }}
                  csvFilename={`Sub Facility`}
                />
              ) : (
                <TableSkeleton />
              )}
            </Box>
          </Item>
        </WithPermission>
      </Grid>
      <WardsForm
        // titleName={menus["subfacility"] ?? ""}
        isDialogOpened={isOpen}
        handleCloseDialog={handleCloseWardsForm}
        action={handelaction}
        addSubFacilty={addSubFacilty}
        filterData={filterData}
      />
    </Grid>
  );
}
